const project = {
  slug: "medicare-healthcare-app",
  title: "Medicare - Mobile Healthcare Management",
  oneLiner: "All-in-one mobile app for appointments, records sharing, secure comms and payments.",
  role: ["Mobile App Developer (Flutter)"],
  category: "App Development",
  clientOrOrg: "Uva Wellassa University - Group Project",
  timeframe: { start: "2023-06", end: "2023-11", status: "Archived" },
  domain: ["HealthTech", "Mobile"],
  tech: ["Flutter", "Android Studio"],
  links: {},
  impact: [
    "Enabled remote booking, file sharing of medical records, and patient-provider messaging.",
    "Improved patient engagement via mobile-first flows and notifications."
  ],
  responsibilities: [
    "Built core Flutter UI and state management.",
    "Implemented appointment booking, records upload and privacy flows."
  ],
  features: [
    "Online booking & reminders",
    "Secure records sharing",
    "Patient-provider chat / remote comms",
    "Online payments"
  ],
  architecture: [
    "Flutter mobile app (Android)",
    "Secure storage for medical records",
    "Provider endpoints/integrations (app-layer abstraction)"
  ],
  seo: {
    title: "Medicare - Mobile Healthcare Management (Flutter)",
    description: "Built a mobile healthcare app for bookings, records sharing, secure communication and payments using Flutter."
  },
  cover: "/assets/medicare/healthcare-mobile-app.png"
};

export default project;
